import React from "react"
import Lottie from "@shared/uiNew/LazyLottie"
import { useInView } from "react-intersection-observer"

import lineAnimationQuestion from "@shared/animations/dialog_bubble.json"
import markerAnimation from "@shared/animations/animation_7.json"

import FAQ from "@widgets/FAQ"

import * as style from "./styles.module.scss"

const NewFAQ = ({ faq }) => {
  const inViewOptions = { triggerOnce: true, threshold: 0.2 }
  const { ref: questionsRef, inView: questionsInView } = useInView(inViewOptions)

  return (
    <section ref={questionsRef} className={`${style.questions} questionsNew`}>
      <h2 className="h1">
        Ответы на{" "}
        <span className={style.highlightDecor}>
          популярные
          {questionsInView && <Lottie animationData={lineAnimationQuestion} loop={false} autoplay={true} />}
        </span>
        <br />
        <span className={style.highlight}>
          вопросы
          {questionsInView && <Lottie animationData={markerAnimation} loop={false} autoplay={true} />}
        </span>
      </h2>
      <FAQ isTitle={true} items={faq} />
    </section>
  )
}

export default NewFAQ
